import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import {
  Tab,
  AnnouncementCard,
  InformationCard,
  FooterSection,
  ContainerFrame,
  MeetUsSection,
  CarouselProduct,  
} from "@components";
import { BriefCase, Laugh } from "@icons";
import {
  CarouselAds,
  FirstSection,
  HubungiKami,
  InspirasiTerkini
} from "./Components";

import { BannerAPI } from "@api";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import "./Home.scss";

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const Home = function () {
  const { t } = useTranslation();
  const [carouselWide, setCarouselWide] = useState(null);
  const [carouselPerorangan, setCarouselPerorangan] = useState(null);
  const [carouselAdsIndex, setCarouselAdsIndex] = useState(0);

  useEffect(() => {
    const loadCarousel = async () => {
      const { data } = await BannerAPI({ loc: "home_business" });
      setCarouselWide(data.data);
    };

    const loadCarouselPerorangan = async () => {
      const { data } = await BannerAPI({ loc: "home_perorangan" });
      setCarouselPerorangan(data.data);
    };

    if (carouselWide === null) {
      loadCarousel();
    }

    if (carouselPerorangan === null) {
      loadCarouselPerorangan();
    }
  }, [carouselWide, carouselPerorangan]);

  return (
    <Container className="vh-100">
      <FirstSection />
      <div>
        <div className="carousel-home-section overflow-hidden">
          <div className="carousel-home-section-tab">
            <Tab.ContainerLg>
              <Tab.ItemLg
                selected={carouselAdsIndex === 0}
                onClick={() => setCarouselAdsIndex(0)}
              >
                <BriefCase className="align-middle icon" />
                <span className="align-middle"> {t("bisnis")}</span>
              </Tab.ItemLg>
              <Tab.ItemLg
                selected={carouselAdsIndex === 1}
                onClick={() => setCarouselAdsIndex(1)}
              >
                <Laugh className="align-middle icon" />
                <span className="align-middle"> {t("perseorangan")}</span>
              </Tab.ItemLg>
            </Tab.ContainerLg>
          </div>
          <div className="carousel-home-section-tab-item">
            {carouselAdsIndex === 0 ? (
              <CarouselAds items={carouselWide} />
            ) : (
              <CarouselAds items={carouselPerorangan} />
            )}
          </div>
        </div>
        <ContainerFrame>
          <Row>
            <Col md={4}>
              <AnnouncementCard />
            </Col>
            <Col md={8}>
              <InformationCard />
            </Col>
          </Row>
        </ContainerFrame>
      </div>
      <InspirasiTerkini />
      <CarouselProduct />
      <HubungiKami />
      <MeetUsSection />
      <div className="overflow-hidden">
        <Row className="">
          <Col className="p-0">
            <FooterSection currentPage={t("home")}/>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Home;
